import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const SUBSCRIPTIONS_SUBSCRIPTION_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/subscriptions',
        iconClass: 'fas fa-file-alt',
        name: '::Menu:Subscriptions',
        layout: eLayoutType.application,
        requiredPolicy: 'Mandir.Subscriptions',
      },
    ]);
  };
}
